import React from 'react';
import { useNavigate } from "react-router-dom";
const AccessDenied = () => {
    const navigate = useNavigate()
    const containerStyle = {
        textAlign: 'center',
        marginTop: '50px',
    };

    const headingStyle = {
        fontSize: '2em',
        color: '#c0392b', // Red color
    };

    const messageStyle = {
        fontSize: '1.2em',
        marginBottom: '20px',
    };

    
    const detailsTextStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      };
    return (
        <section className="product-details spad">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="product__details__text" style={{ ...containerStyle, ...detailsTextStyle }}>
                            <h3 style={headingStyle}>Accès refusé !!</h3>
                            <p style={messageStyle}>Vous devez vous connecter pour accéder à cette page.</p>
                            <div className="product__details__button">
                                <a className="cart-btn" onClick={() => {navigate("/login")}} style={{ cursor: 'pointer' }}> Login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AccessDenied;
